<template>
  <div class="empty">
    <router-view/>
  </div>
</template>

<script>
export default {}
</script>
